export const CARS_AVERAGE_COST_VALUE = {
  'Aygo': 306.65, // Aygo X
  'Yaris Hybrid': 355.31,
  'Yaris Cross': 318.04,
  'Corolla Hybrid': 333.54,
  'Corolla Cross': 335.56,
  'C-HR': 420.02, // C-HR Hybrid
  // 'RAV4 Hybrid': '', // TODO: missing in excel doc
};
